import { shuffle } from "lodash";
import { db } from "../../firebase";

import { arrayUnion, doc, increment, updateDoc } from "firebase/firestore";
import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { formatTime } from "../../App";
import deepCopy from "../hooks/deepCopy";
import { fakeCard } from "../../util/gameDefault";
import { commonAction } from "../../slices/GameSlice";

const FakeCardHooks = () => {
  const dispatch = useDispatch();
  const {
    fakeCard: {
      fakeCardUsers,
      turnUser,
      turnStep,
      // gameStatus,
      submitUser,
      submitLogList,
      cardArr,
      firstCard,
      passCount,
      voteCount,
      passVoteCount,
    },
    fakeCardSubmitList,
    fakeCardSubmitLabel,
    roomId,
    message,
  } = useSelector((state) => state.GameSlice);
  const { userId, nickname } = useSelector((state) => state.LoginInfoSlice);

  const liveCount = useMemo(
    () => fakeCardUsers.filter((i) => !i?.end)?.length,
    [fakeCardUsers]
  );

  const JoinFakeCard = useCallback(() => {
    const docRef = doc(db, "game", `room${roomId}`);
    updateDoc(docRef, {
      "fakeCard.fakeCardUsers": arrayUnion({
        userId,
        nickname,
        cards: [],
        end: false,
      }),
    });

    updateDoc(docRef, {
      "fakeCard.fakeCardUsers": arrayUnion({
        userId: "test1",
        nickname: "test1",
        cards: [],
        end: false,
      }),
    });
  }, [roomId, userId, nickname]);

  const ExitFakeCard = useCallback(() => {
    const docRef = doc(db, "game", `room${roomId}`);

    const remainUsers = fakeCardUsers.filter((i) => i?.userId !== userId);

    updateDoc(docRef, {
      "fakeCard.fakeCardUsers": remainUsers,
    });
  }, [roomId, fakeCardUsers, userId]);

  const ResetGame = useCallback(() => {
    const docRef = doc(db, "game", `room${roomId}`);
    updateDoc(docRef, {
      fakeCard,
    });
  }, [roomId]);

  const StartFakeCard = useCallback(() => {
    const docRef = doc(db, "game", `room${roomId}`);
    let baseCards = initialFakeCard();
    let updateUsers = deepCopy(fakeCardUsers);
    for (let i = 0; i < updateUsers.length; i++) {
      updateUsers[i].cards = baseCards.splice(0, 10);
    }

    updateDoc(docRef, {
      "fakeCard.fakeCardUsers": updateUsers,
      "fakeCard.gameStatus": true,
      "fakeCard.turnUser": updateUsers[0],
      "fakeCard.submitUser": updateUsers[0],
      "fakeCard.cardArr": baseCards,
      "fakeCard.gameTurn": increment(1),
      "fakeCard.turnStep": 1,
    });
  }, [roomId, fakeCardUsers]);

  // 카드를 엎는것 외에 모든 행동은 본인의 턴일때만

  // passCount => 카드 제출 후 넘길지 말지,
  // voteCount => 투표를 시작 할지 말지 (제출 안할때마다 1씩 증가)
  // passVoteCount => 다음 유저가 제출할지에 대한 카운트

  const SubmitCards = useCallback(() => {
    // step == 1 or 2
    // fakeCardSubmitList => 낼 카드 리스트
    // fakeCardSubmitLabel => 카드 라벨

    if (fakeCardSubmitList.length && fakeCardSubmitLabel) {
      const docRef = doc(db, "game", `room${roomId}`);

      let updateUsers = deepCopy(fakeCardUsers);

      const findIndex = updateUsers.findIndex((i) => i?.userId === userId);

      // fakeCardSubmitList에 없는 카드들만 남기기 필터
      updateUsers[findIndex].cards = updateUsers[findIndex].cards.filter(
        (i) =>
          !fakeCardSubmitList.find(
            (j) => j.label === i.label && j.order === i.order
          )
      );

      let nextIndex = findIndex + 1;

      while (updateUsers[nextIndex]?.end) {
        nextIndex += 1;
      }

      const nextSubmitUser = updateUsers[nextIndex] || updateUsers[0];
      const logItem = { userId, nickname, items: fakeCardSubmitList };

      const updateDB = {
        "fakeCard.fakeCardUsers": updateUsers,
        "fakeCard.turnUser": nextSubmitUser,
        "fakeCard.turnStep": 3,
        "fakeCard.submitLogList": arrayUnion(logItem),
        "fakeCard.passCount": 0,
        "fakeCard.voteCount": 0,
        "fakeCard.passVoteCount": 0,
      };

      if (turnStep === 1) {
        updateDB["fakeCard.firstCard"] = fakeCardSubmitLabel;
      }

      updateDoc(docRef, updateDB);
      dispatch(commonAction({ target: "fakeCardSubmitList", value: [] }));
      dispatch(commonAction({ target: "fakeCardSubmitLabel", value: "" }));
    } else {
      toast.error("제출할수 없습니다.");
    }
  }, [
    dispatch,
    fakeCardSubmitList,
    fakeCardSubmitLabel,
    fakeCardUsers,
    roomId,
    userId,
    nickname,
    turnStep,
  ]);

  const OverCards = useCallback(() => {
    const docRef = doc(db, "game", `room${roomId}`);

    const checkAnswer = submitLogList[submitLogList.length - 1]?.items?.every(
      (i) => i?.label === firstCard
    );

    const lastOrder = message[0]?.order + 1 || 1;
    const newMessage = {
      text: `님이 카드를 뒤집었습니다!`,
      order: lastOrder,
      userId,
      nickname,
      type: "system",
      date: formatTime(new Date()),
    };

    const findUser = fakeCardUsers.find(
      (i) => i?.userId === submitLogList[submitLogList.length - 1]?.userId
    );

    const updateDB = {
      "fakeCard.turnStep": 4,
      message: arrayUnion(newMessage),
    };

    if (checkAnswer) {
      updateDB["fakeCard.turnUser"] = findUser;
    }

    updateDoc(docRef, updateDB);
  }, [
    roomId,
    fakeCardUsers,
    message,
    userId,
    nickname,
    submitLogList,
    firstCard,
  ]);

  const checkIncludes = useMemo(
    () => fakeCardUsers.some((i) => i?.userId === userId),
    [fakeCardUsers, userId]
  );

  const NotOverCard = useCallback(() => {
    const docRef = doc(db, "game", `room${roomId}`);
    const findIndex = fakeCardUsers.findIndex((i) => i?.userId === userId);

    let nextIndex = findIndex + 1;

    while (fakeCardUsers[nextIndex]?.end) {
      nextIndex += 1;
    }
    // 제출한 사람은 제외 -1
    if (passCount + 1 === liveCount - 1) {
      // 모두가 패스 하면  다음 제출로
      const lastSubmitUserId = submitLogList[submitLogList.length - 1]?.userId;
      const lastSubmitIndex = fakeCardUsers.findIndex(
        (i) => i?.userId === lastSubmitUserId
      );
      let nextSubmitIndex = lastSubmitIndex + 1;

      while (fakeCardUsers[nextSubmitIndex]?.end) {
        nextSubmitIndex += 1;
      }
      const nextSubmitUser = fakeCardUsers[nextSubmitIndex] || fakeCardUsers[0];

      // 안뒤집으면 위에 얹는 상황 => step = 2

      updateDoc(docRef, {
        "fakeCard.turnUser": nextSubmitUser,
        "fakeCard.gameTurn": increment(1),
        "fakeCard.passCount": 0,
        "fakeCard.turnStep": 2,
      });
    } else {
      updateDoc(docRef, {
        "fakeCard.gameTurn": increment(1),
        "fakeCard.passCount": increment(1),
      });
    }
  }, [roomId, userId, fakeCardUsers, passCount, submitLogList, liveCount]);

  // turnStep ===2일때 패스 행동을 할 경우
  const PassCard = useCallback(() => {
    const docRef = doc(db, "game", `room${roomId}`);
    let updateUsers = deepCopy(fakeCardUsers);
    let updateCards = deepCopy(cardArr);
    const findIndex = updateUsers.findIndex((i) => i?.userId === userId);
    if (updateCards.length) {
      const [pushCard] = updateCards.splice(0, 1);
      updateUsers[findIndex].cards.push(pushCard);
    }

    let nextIndex = findIndex + 1;

    while (updateUsers[nextIndex]?.end) {
      nextIndex += 1;
    }

    const nextUser = updateUsers[nextIndex] || updateUsers[0];

    updateDoc(docRef, {
      "fakeCard.fakeCardUsers": updateUsers,
      "fakeCard.turnUser": nextUser,
      "fakeCard.cardArr": updateCards,
      "fakeCard.gameTurn": increment(1),
      "fakeCard.voteCount": increment(1),
      "fakeCard.passVoteCount": 0,
    });
  }, [roomId, userId, fakeCardUsers, cardArr]);

  const BringCards = useCallback(() => {
    // 카드를 가져오고, 다음 제출 턴으로 넘김
    const docRef = doc(db, "game", `room${roomId}`);

    let updateUsers = deepCopy(fakeCardUsers);

    let submitIndex =
      updateUsers.findIndex((i) => i?.userId === submitUser?.userId) + 1;

    const myIndex = updateUsers.findIndex((i) => i?.userId === userId);

    let totalLogItem = [];
    submitLogList.forEach((i) => {
      totalLogItem = [...totalLogItem, ...i.items];
    });
    updateUsers[myIndex].cards = [
      ...updateUsers[myIndex].cards,
      ...totalLogItem,
    ];

    while (updateUsers[submitIndex]?.end) {
      submitIndex += 1;
    }

    const nextSubmitUser = updateUsers[submitIndex] || updateUsers[0];

    updateDoc(docRef, {
      "fakeCard.fakeCardUsers": updateUsers,
      "fakeCard.submitUser": nextSubmitUser,
      "fakeCard.turnUser": nextSubmitUser,
      "fakeCard.gameTurn": increment(1),
      "fakeCard.passCount": 0,
      "fakeCard.voteCount": 0,
      "fakeCard.passVoteCount": 0,
      "fakeCard.submitLogList": [],
      "fakeCard.turnStep": 1,
    });
  }, [roomId, fakeCardUsers, submitUser, submitLogList, userId]);

  // voteCount가  liveCount와 같으면 PassVote 투표 시작
  const PassVote = useCallback(() => {
    const docRef = doc(db, "game", `room${roomId}`);

    // 모두가 넘어가자고 투표했을경우 step => 5 마지막 submitUser 다음 사람으로 턴 넘기기
    if (passVoteCount + 1 === liveCount) {
      let submitIndex =
        fakeCardUsers.findIndex((i) => i?.userId === submitUser?.userId) + 1;
      while (fakeCardUsers[submitIndex]?.end) {
        submitIndex += 1;
      }

      const nextSubmitUser = fakeCardUsers[submitIndex] || fakeCardUsers[0];
      updateDoc(docRef, {
        "fakeCard.submitUser": nextSubmitUser,
        "fakeCard.turnUser": nextSubmitUser,
        "fakeCard.turnStep": 5,
        "fakeCard.passCount": 0,
        "fakeCard.voteCount": 0,
        "fakeCard.passVoteCount": 0,
      });
    } else {
      updateDoc(docRef, {
        "fakeCard.passVoteCount": increment(1),
      });
    }
  }, [roomId, passVoteCount, fakeCardUsers, submitUser, liveCount]);

  const ReturnSubmit = useCallback(() => {
    const docRef = doc(db, "game", `room${roomId}`);
    updateDoc(docRef, {
      "fakeCard.turnStep": 1,
    });
  }, [roomId]);

  return {
    JoinFakeCard,
    ExitFakeCard,
    ResetGame,
    StartFakeCard,
    SubmitCards,
    OverCards,
    PassCard,
    NotOverCard,
    BringCards,
    PassVote,
    ReturnSubmit,
    liveCount,
    checkIncludes,
  };
};

const initialFakeCard = () => {
  let arr = [];

  const cards = ["map", "ceramic", "compass", "coin", "machete", "canteen"];

  cards.forEach((item) => {
    for (let i = 0; i < 10; i++) {
      arr.push({ label: item, order: i });
    }
  });

  return shuffle(arr);
};

export default FakeCardHooks;
